import QuestionIcon from '../../../../public/images/question_big.png'
import styles from './Label.module.scss'
import { t } from '../translations'
import { PropsWithChildren, useState } from 'react'

interface LabelProps {
    for?: string
    tooltip?: string
}

export const Label = ({
    for: id,
    tooltip,
    children,
}: PropsWithChildren<LabelProps>) => {
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <div className={styles.labelWrapper}>
            <label htmlFor={id} className={styles.label}>
                {children}
            </label>
            {tooltip && (
                <img
                    className={styles.tooltipIcon}
                    src={QuestionIcon}
                    alt="ToolTip"
                    onClick={() => setShowTooltip(!showTooltip)}
                />
            )}
            {showTooltip && tooltip && (
                <span
                    className={styles.tooltip}
                    onClick={() => setShowTooltip(false)}
                    dangerouslySetInnerHTML={{
                        __html: t(tooltip),
                    }}
                ></span>
            )}
        </div>
    )
}
